import * as _ from 'lodash';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ChooseImageModalService } from 'app/core/services/choose-image-modal.service';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ImagesFilterPopoverComponent } from '../../images-filter-popover/images-filter-popover.component';
import { CampaignService } from 'app/campaign/services/campaign.service';
import { MdbInfiniteScrollModule } from 'mdb-angular-ui-kit/infinite-scroll';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-choose-image',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ImagesFilterPopoverComponent, MdbInfiniteScrollModule],
  templateUrl: './choose-image.component.html',
  styleUrl: './choose-image.component.scss'
})
export class ChooseImageComponent implements OnInit, OnDestroy{
  destroyRef = inject(DestroyRef)
  @Input () data: any = null;

  public sortedImages: any = [];
  public selectedImage: string = '';
  public search: UntypedFormControl = new UntypedFormControl('', []);
  public filteredImages = [];
  public imagesCategories = [];
  public start = 0;
  public index = 0;
  public loading = false;
  public disableInfiniteScroll = false;

  public isMultipleSelection = false;
  public subtitle: string = '';
  public btnTitle: string = '';
  public selectedImages: string[] = [];

  constructor(
    public chooseImageModalService: ChooseImageModalService,
    public campaignService:CampaignService
  ) {}

  ngOnInit() {
    const images = this.data.images;
    this.sortedImages = _.sortBy(images, image => new Date(image.updated)).reverse().filter(img=>(img.imageUrl !== '/images/blank_2x1.png' && img.imageUrl !== ''));
    this.imagesCategories = this.sortedImages.map(image=>(image.usedFor))
    this.chooseImageModalService.filteredImages = this.sortedImages;
    this.chooseImageModalService.images = this.sortedImages;
    this.chooseImageModalService.type = '';
    this.disableInfiniteScroll = false;
    this.isMultipleSelection = this.data.multiple || false;
    this.subtitle = `Choose ${this.isMultipleSelection ? 'one or more images' : 'image'} from previously used images`;

    this.search.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(search => {
      this.chooseImageModalService.searchQuery = search
      this.chooseImageModalService.filterImages();
    });
  }

  onClickImage(url) {
    if (this.isMultipleSelection) {
      const index = this.selectedImages.indexOf(url);
      if (index > -1) {
        this.selectedImages.splice(index, 1);
      } else {
        this.selectedImages.push(url);
      }
    } else {
      this.selectedImages = [url];
    }

    this.btnTitle = `Add (${this.selectedImages.length} image${this.selectedImages.length > 1 ? 's' : ''})`
  }

  isSelected(url: string): boolean {
    return this.selectedImages.includes(url);
  }

  onClickUpload() {
    this.close('upload');
  }

  close(placeOfCall = 'cross') {
    switch (placeOfCall) {
      case 'upload':
        if (this.selectedImages.length > 1) { 
          this.chooseImageModalService.close(this.selectedImages); // returns array
        } else {
          this.chooseImageModalService.close(this.selectedImages[0]); // returns obj
        }
        break;
      case 'cross':
        this.chooseImageModalService.close(null);
        break;
    }
  }

  onComplete(): void {
    if(!this.loading && typeof this.chooseImageModalService.type == "string"  && 
        this.chooseImageModalService.searchQuery == '' && !this.disableInfiniteScroll) {

      this.loading = true;
      this.start += 40;
      const params = {
        start: this.start,
        returnCount: 40,
        filterBy:[this.data.type]
      }

      this.campaignService.getOrganizationImages(params).pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((imageList: any)=> {
        if(imageList.length < 40){
          this.disableInfiniteScroll = true
        }
        // let imagesByType = imageList.filter((img)=>(img.type == this.data.type))
        this.chooseImageModalService.images = [...this.chooseImageModalService.images, ...imageList]
        this.chooseImageModalService.filteredImages = [...this.chooseImageModalService.images, ...imageList]
        this.index++;
        this.loading = false;
      })
    }
  }

  resetSearch() {
    this.search.setValue('');
  }

  ngOnDestroy(): void {
    this.disableInfiniteScroll = false;
  }
}
